import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { SmartBannerComponent } from './smart-banner.component';

@NgModule({
  imports: [NgIf, AsyncPipe, RouterLink, SdvorButtonComponent],
  declarations: [SmartBannerComponent],
  exports: [SmartBannerComponent],
})
export class SmartBannerComponentModule {}
